export default __webpack_public_path__ + "static/media/2.48928ea5.png";